import { combineReducers } from "redux";
import auth from "redux/reducer/auth/auth.reducer";
import common from "./common";
import audioPlayer from "./audio-player";
import memorize from "./memorize";
import modal from "./modal";
export default combineReducers({ memorize, common, modal, auth, audioPlayer });
